import React,{useState} from 'react'

import Header from './Header';

import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signInWithRedirect } from "firebase/auth";
import './styles/LoginPage.css'
import { useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import firebaseConfig from '../firebase/config';

import {useAuth0} from '@auth0/auth0-react'

function LoginPage() {

    const {loginWithPopup,loginWithRedirect,logout,user, isAuthenticated} = useAuth0()

    const [usernameField, setUsernameField] = useState('');
    const [fullNameField, setFullNameField] = useState('');
    const [emailField, setEmailField] = useState('');
    const [passwordField, setPasswordField] = useState('');
    const [confirmPasswordField, setConfirmPasswordField] = useState('');



    const [loggedIn,setLoggedIn] = useState(false);



    const app = initializeApp(firebaseConfig)
    //const auth = getAuth();
    
    
    
    useEffect(()=>{
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
              // User is signed in, see docs for a list of available properties
              // https://firebase.google.com/docs/reference/js/firebase.User
              const uid = user.displayName;
              setLoggedIn(true);
                console.log("Logged in")
              window.location.replace('/');
              // ...
            } else {
              // User is signed out
              // ...

              setLoggedIn(false);
            }
          });
        
    },[])

    

    const googleSignInClick=()=>{
        console.log("HI")
        const auth = getAuth();
        const provider = new GoogleAuthProvider();
        signInWithRedirect(auth, provider)
        .then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            // ...
        }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.email;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            // ...
            console.log(errorMessage)
        });
        // onAuthStateChanged(auth, (user) => {
        //     if (user) {
        //       // User is signed in, see docs for a list of available properties
        //       // https://firebase.google.com/docs/reference/js/firebase.User
        //       const uid = user.displayName;
        //       setLoggedIn(true);
        //         console.log("Logged in")
        //       window.location.replace('/');
        //       // ...
        //     } else {
        //       // User is signed out
        //       // ...

        //       setLoggedIn(false);
        //     }
        //   });

    }

    
    const signUpButtonClick=()=>{
        const signUpButton = document.getElementById('signUpp');
        const container = document.getElementById('container69');
       
        container.classList.add("right-panel-active");
       
    }
    
    const signInButtonClick=()=>{
        const signInButton = document.getElementById('signInn');
        const container = document.getElementById('container69');
       
            container.classList.remove("right-panel-active");
      
    }


    return (
        <>{loginWithRedirect()}</>
    )
}

export default LoginPage
